export default __webpack_public_path__ + "assets/02_OpenMap.png";